import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Cryptocurrency02 = function Cryptocurrency02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M17.8779 20.0899a10 10 0 0 1-11.7557 0m10.2615-17.078a10 10 0 0 1 5.519 10.3796m-19.8053-.0001a10 10 0 0 1 5.519-10.3797m3.8179 3.5537-4.8686 4.8687c-.198.198-.297.297-.3341.4111a.5.5 0 0 0 0 .3091c.037.1141.136.2131.334.4111l4.8687 4.8687c.198.198.297.297.4112.3341a.5.5 0 0 0 .309 0c.1142-.0371.2132-.1361.4112-.3341l4.8686-4.8687c.198-.198.297-.297.3341-.4111a.5.5 0 0 0 0-.3091c-.0371-.1141-.1361-.2131-.3341-.4111l-4.8686-4.8687c-.198-.198-.297-.297-.4112-.334a.5.5 0 0 0-.309 0c-.1142.037-.2132.136-.4112.334"
    })
  }));
};
export default Cryptocurrency02;